import { render, staticRenderFns } from "./TipoManutencaoIbp.vue?vue&type=template&id=401f8bd7"
import script from "./TipoManutencaoIbp.vue?vue&type=script&lang=js"
export * from "./TipoManutencaoIbp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports